<template>
   <div id="admin-menu">
      <el-collapse accordion>
         <router-link :to="{name: 'admin-map'}" class='link main'>
            Dashboard
         </router-link>
         <el-collapse-item   class='default' title="Plan" name="plan">
            <router-link :to="{name: 'admin-plan-list'}" class='link'>Plans</router-link>
            <!-- <router-link to="#3" class='link'>Shared Plans</router-link> -->
         </el-collapse-item>
         <el-collapse-item   class='default' title="User" name="user">
            <router-link :to="{name: 'user-list'}" class='link'>Users</router-link>
            <router-link :to="{name: 'add-user'}" class='link'>Create</router-link>
         </el-collapse-item>
         <el-collapse-item   class='default' title="Edit energy costs" name="energy-costs">
            <router-link :to="{name: 'shs-dc-costs'}" class='link'>SHS DC Costs</router-link>
            <router-link :to="{name: 'shs-ac-costs'}" class='link'>SHS AC Costs</router-link>
            <router-link :to="{name: 'grid-costs'}" class='link'>Grid Costs</router-link>
            <router-link :to="{name: 'mhp-costs'}" class='link'>Mini-hydro power Costs</router-link>
            <router-link :to="{name: 'smg-costs'}" class='link'>Solar Mini-Grid Costs</router-link>
         </el-collapse-item>
      </el-collapse>
   </div>
</template>

<script>
import { Collapse,CollapseItem } from 'element-ui';

export default {
   components: {

      'el-collapse': Collapse,
      'el-collapse-item': CollapseItem,
  },
};
</script>

<style lang="scss">
#admin-menu {
   .link  {
      display: block;
      color: $font-color;
      font-size: 13px;
      background: whitesmoke;
      width: 100%;
      padding: 1em;
      cursor: pointer;
   }
   .link.main {
      border-bottom: 1px solid #dfdfdf;
   }
   .el-collapse-item {
      &__header{
         background: whitesmoke;
         padding: 0 1em;
      }
      &__content { 
         padding: 0 0 0 1em;
         background: #f5f5f5;
      }
      &__content .link {
         padding: 0.6em 1em;
      }
   }
   .link,
   .el-collapse-item__header {
      &:hover {
         background: rgba($primary-color, 90%);
         color: white;
      }
      &:active,
      &.router-link-active,
      &.is-active {
         box-shadow: inset 3px 0 0px $primary-color;
      }
   }
   .el-collapse-item__header.is-active {
      border-bottom: solid 1px rgba($primary-color, 10%);
   }

}

</style>
